import { render } from "./MobileWrapper.vue?vue&type=template&id=311a5651&scoped=true"
const script = {}

import "./MobileWrapper.vue?vue&type=style&index=0&id=311a5651&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-311a5651"]])

export default __exports__